import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LangService } from '../../../controller/lang-service';

@Component({
  selector: 'app-technologies',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './technologies.html',
  styleUrls: ['./technologies.css']
})
export class Technologies {

  lang = inject(LangService);

  techList = [
    {
      name: 'Node.js',
      label: 'tech.node',
      logo: 'https://cdn.simpleicons.org/nodedotjs/339933' 
    },
    {
      name: 'Angular',
      label: 'tech.angular',
      logo: 'https://cdn.simpleicons.org/angular/DD0031'
    },
    {
      name: 'Flutter',
      label: 'tech.flutter',
      logo: 'https://storage.googleapis.com/cms-storage-bucket/4fd5520fe28ebf839174.svg'
    },
    {
      name: 'MongoDB',
      label: 'tech.mongodb',
      logo: 'https://cdn.simpleicons.org/mongodb/47A248'
    },
    {
      name: 'REST',
      label: 'tech.rest',
      logo: 'https://cdn.simpleicons.org/postman/FF6C37' 
    },
    {
      name: 'GraphQL',
      label: 'tech.graphql',
      logo: 'https://cdn.simpleicons.org/graphql/E10098'
    }
  ];
}
